import { DEFAULT_LOCALE, type AppLocale } from '~/utils/i18n';

type HeadCopy = {
  title: string;
  description: string;
};

export const ROOT_ROUTE_HEAD_COPY: Record<AppLocale, HeadCopy> = {
  en: {
    title: 'Trypillian',
    description: 'Welcome to Trypillian',
  },
  uk: {
    title: 'Trypillian',
    description: 'Ласкаво просимо до Trypillian',
  },
};

interface RootHeadConfigOptions {
  locale: AppLocale;
  appStylesHref: string;
}

export const ROOT_ROUTE_HEAD_LINKS = [
  { rel: 'icon', href: '/favicon.svg', type: 'image/svg+xml' },
] as const;

export function createRootHeadConfig({
  locale,
  appStylesHref,
}: RootHeadConfigOptions) {
  const copy =
    ROOT_ROUTE_HEAD_COPY[locale] ?? ROOT_ROUTE_HEAD_COPY[DEFAULT_LOCALE];

  return {
    meta: [
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { title: copy.title },
      { name: 'description', content: copy.description },
    ],
    links: [
      // Preload LCP elements - hero video poster
      { rel: 'preload', as: 'image', href: '/assets/images/first_frame.png', fetchPriority: 'high' as const },
      // Preconnect to Google Fonts CDN (where actual font files are hosted)
      { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossOrigin: 'anonymous' as const },
      // Preload critical CSS for faster render
      { rel: 'preload', as: 'style', href: appStylesHref },
      // Load stylesheet
      { rel: 'stylesheet', href: appStylesHref },
      // Fonts - Only load latin & cyrillic subsets for English/Ukrainian
      // Using API v1 with subset parameter to avoid loading unnecessary character sets
      { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css?family=Manrope:300,400,500,700&subset=latin,cyrillic' },
      { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css?family=Fragment+Mono:300,400,400i&subset=latin' },
      ...ROOT_ROUTE_HEAD_LINKS,
    ],
  };
}
